import PubSub from "pubsub-js";

export const Event = {
  /**
   * Evento que se dispara cuando se realiza una busqueda de cuenta 
   * correinte o padrón.
   */
  VISOR_BUSQUEDA: "VISOR_BUSQUEDA",
  VISOR_FEATURE_INFO: "VISOR_FEATURE_INFO",
  VISOR_CLICK_INFO: "VISOR_CLICK_INFO",
  VISOR_LONLAT:"VISOR_LONLAT",
  VISOR_CURRENT_LOCATION:"VISOR_CURRENT_LOCATION",

  MAP_FEATURE_READY: "MAP_FEATURE_READY",
  MAP_FEATURE_ERROR: "MAP_FEATURE_ERROR",

  publish(event, data) {
    PubSub.publish(event, data);
  },

  subscribe(event, suscriber) {
    return PubSub.subscribe(event, (msg, data) => {
      suscriber(data);
    });
  },

  unsubscribe(token) {
    PubSub.unsubscribe(token);
  }
};
